import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    medalList: [],
    timesPrizeList: [],
    box1List: [],
    box2List: [],
    USERINFO:{}
  },
  mutations: {
    getMedalList(state, msg) {
      state.medalList = msg
    },
    getTimesPrizeList(state, msg) {
      state.timesPrizeList = msg
    },
    getBox1List(state, msg) {
      state.box1List = msg
    },
    getBox2List(state, msg) {
      state.box2List = msg
    },
    getUserInfo(state,userInfo) {
      state.USERINFO = userInfo
    }
  },
  actions: {},
  modules: {}
});




// WEBPACK FOOTER //
// ./src/store/index.js